export default "__VITE_ASSET__Ddq48OIn__"